"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const NextIcon = ({ idNextIconButton }) => {
    return (react_1.default.createElement("button", { id: idNextIconButton, type: "button", className: "calendar-navigation button-right", "data-testid": "next-month" },
        react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE315")));
};
exports.default = NextIcon;
//# sourceMappingURL=NextIcon.js.map